export default {
  'nav.poti': 'Rutas',
  'nav.izhodisca': 'Puntos de Partida',
  'nav.galerija': 'Galería',
  'nav.vreme': 'Clima',
  'nav.o_nas': 'Sobre Nosotros',
  'nav.zacni_pot': 'Iniciar Ruta',
  'nav.odpri_meni': 'Abrir menú',
  'nav.zapri_meni': 'Cerrar menú',
  'nav.preskoci': 'Saltar al contenido',

  'hero.badge': 'Asociación Turística STEZA — Šmarna Gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'Una de las rutas más hermosas, variadas y acogedoras para visitantes de todas las generaciones.',
  'hero.cta_start': 'Iniciar Ruta',
  'hero.cta_explore': 'Explorar Rutas',
  'hero.cta_activities': 'Actividades',
  'hero.scroll': 'Desplázate',

  'intro.badge': 'Bienvenidos',
  'intro.title': 'Šmarna Gora, la colina más querida de Liubliana',
  'intro.desc': 'Šmarna Gora, la colina más popular cerca de Liubliana, ofrece numerosas rutas para excursionistas, corredores y amantes de la naturaleza.',
  'intro.highlight': 'La Ruta Peske es considerada uno de los caminos más hermosos, variados y acogedores para visitantes de todas las edades.',
  'intro.pot_label': 'Ruta Peske',
  'intro.route': 'Spodnje Pirniče → Šmarna Gora',

  'activities.badge': 'Actividades',
  'activities.title': 'EXPLORANDO ŠMARNA GORA',
  'activities.hiking.title': 'Senderismo en Šmarna Gora',
  'activities.hiking.desc': 'Descubre diversas rutas, desde paseos fáciles hasta ascensiones más exigentes.',
  'activities.cycling.title': 'Ciclismo alrededor de Šmarna Gora',
  'activities.cycling.desc': 'Explora rutas ciclistas panorámicas en los alrededores con hermosas vistas.',
  'activities.running.title': 'Trail Running en Šmarna Gora',
  'activities.running.desc': 'Un destino popular para corredores de trail — terreno variado con pendiente ideal.',
  'activities.running_around.title': 'Correr alrededor de Šmarna Gora',
  'activities.running_around.desc': 'Circuitos de running planos y suaves en la base, ideales para entrenamiento recreativo.',
  'activities.walks.title': 'Paseos al pie de Šmarna Gora',
  'activities.walks.desc': 'Paseos tranquilos por prados y senderos forestales, ideales para familias.',

  'access.badge': 'Punto de Partida',
  'access.title': 'PUNTO DE PARTIDA Y ACCESO',
  'access.desc': 'La ruta comienza en el aparcamiento LIPA en Spodnje Pirniče. El acceso es fácil — en coche o autobús.',
  'access.start_label': 'Punto de Partida de la Ruta',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Aparcamiento LIPA',
  'access.parking': 'Aparcamiento',
  'access.free': 'Gratuito',
  'access.bus': 'Autobús',
  'access.bus_line': 'Línea 25',
  'access.info1': 'Aparca tu vehículo en el parking LIPA o llega en autobús número 25 directamente al punto de partida frente al restaurante con una hermosa terraza, donde podrás disfrutar de una bebida refrescante o un tentempié antes de comenzar la excursión.',
  'access.info2': 'Al principio, un sendero estrecho cubierto de virutas de madera te conduce junto a un prado hacia el bosque, donde comienza la ascensión.',

  // ── PARKING ──
  'parking.hero_title': 'Aparcamiento LIPA — Punto de partida oficial',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Liubliana-Šmartno. Aparcamiento gratuito justo al inicio del sendero Pot na Peske.',
  'parking.highlight_badge': '⭐ Punto de partida oficial',
  'parking.section_title': 'APARCAMIENTO & ACCESO',
  'parking.intro': 'El aparcamiento LIPA es el punto de partida oficial, gratuito y más conveniente para Pot na Peske — nuestro sendero más hermoso hacia Šmarna gora.',
  'parking.address_label': 'Dirección',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Liubliana-Šmartno, Eslovenia',
  'parking.gps_label': 'Coordenadas GPS',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Capacidad',
  'parking.capacity_value': 'Gratuito, espacio para 20+ vehículos',
  'parking.type_label': 'Tipo de aparcamiento',
  'parking.type_value': 'Aparcamiento de grava al aire libre',
  'parking.hours_label': 'Abierto',
  'parking.hours_value': '24/7 — todo el año',
  'parking.bus_info_title': 'Transporte público',
  'parking.bus_info': 'El autobús LPP línea 25 va directamente a la parada frente al aparcamiento. El trayecto desde el centro de Liubliana dura unos 30 minutos.',
  'parking.facilities_title': 'Servicios',
  'parking.facility_gostilna': 'Restaurante con hermosa terraza junto al aparcamiento',
  'parking.facility_wc': 'WC disponible en el restaurante',
  'parking.facility_info': 'Panel informativo al inicio del sendero Pot na Peske',
  'parking.facility_sign': 'Señal STEZA / Pot na Peske',
  'parking.tips_title': 'Consejos de aparcamiento',
  'parking.tip1': 'Los fines de semana y festivos se llena rápido — llegue temprano (antes de las 8).',
  'parking.tip2': 'El aparcamiento es de grava — en invierno, cuidado con el posible hielo.',
  'parking.tip3': 'No deje objetos de valor en el coche. Aparque bajo su propia responsabilidad.',
  'parking.tip4': 'Aparcamiento adicional disponible en Gostilna Ledinek en Tacen (5 min en coche) si LIPA está lleno.',
  'parking.map_title': 'Ubicación en el mapa',
  'parking.cta_title': '¿Listo para Pot na Peske?',
  'parking.cta_subtitle': 'Aparque en LIPA y emprenda el sendero más hermoso hacia Šmarna gora.',
  'parking.cta_btn': 'Comenzar ruta',
  'parking.cta_routes': 'Todas las rutas',

  'story.badge': 'Ruta Peske',
  'story.title': 'DEL INICIO A LA CIMA',
  'story.subtitle': 'Un viaje cinematográfico por cada etapa de la ruta',
  'story.etapa': 'Etapa',
  'story.blocks.0.title': 'Comienzo Suave',
  'story.blocks.0.text': 'Comenzamos con una suave subida por un sendero cómodo y ancho, parcialmente cubierto de rocas y raíces. Pronto giramos hacia un sendero cada vez más estrecho que asciende un poco más empinado.',
  'story.blocks.0.terrain': 'Sendero ancho, rocas, raíces',
  'story.blocks.1.title': 'Tramo Más Dinámico',
  'story.blocks.1.text': 'Caminamos sobre terreno cada vez más arenoso, sobre rocas y raíces, en parte a través de un barranco relativamente profundo. Esta es la parte más empinada pero también la más variada de la ruta.',
  'story.blocks.1.terrain': 'Terreno arenoso, rocas, barranco',
  'story.blocks.2.title': 'Camino de Grava',
  'story.blocks.2.text': 'Cuando el sendero se ensancha y se nivela, pronto llegamos a un amplio camino de grava, la vía para vehículos hacia Šmarna Gora que viene de Zavrh.',
  'story.blocks.2.terrain': 'Grava, camino ancho',
  'story.blocks.3.title': 'Monumento Turco',
  'story.blocks.3.text': 'Aquí una señal de sendero nos dirige a la derecha, pasando el Monumento de la Peste o Turco, que recuerda los tiempos de las invasiones otomanas.',
  'story.blocks.3.terrain': 'Señal de sendero, punto histórico',
  'story.blocks.4.title': 'Capilla Gorjanc',
  'story.blocks.4.text': 'La carretera sube suavemente por el bosque, que gradualmente se abre. A la izquierda está la Capilla Gorjanc, donde se conserva la costumbre de depositar pequeñas cruces.',
  'story.blocks.4.terrain': 'Camino forestal, capilla',
  'story.blocks.5.title': 'Spodnji Gorjanc — Cruce',
  'story.blocks.5.text': 'Llegamos a Spodnji Gorjanc, un importante cruce de senderos. Aquí se cruzan los caminos hacia Grmada, el Sendero de las Raíces (hacia Tacen) y la continuación hacia Šmarna Gora.',
  'story.blocks.5.terrain': 'Cruce de senderos, Grmada, Sendero de las Raíces',
  'story.blocks.6.title': 'Vistas Alpinas',
  'story.blocks.6.text': 'Continuamos por prados de pastoreo, donde se abren vistas de los Alpes de Kamnik-Savinja y los Alpes Julianos con el Triglav.',
  'story.blocks.6.terrain': 'Prados de pastoreo, vistas panorámicas',
  'story.blocks.7.title': 'Sedlo — Cruce con Grmada',
  'story.blocks.7.text': 'En Sedlo (Collado), el sendero se cruza con la ruta hacia Grmada y se une con los senderos de Tacen, Šmartno y Vikrče. Desde aquí, elige la ruta de grava más fácil o un sendero más estrecho y rocoso pasando la Capilla de Santa Sobota.',
  'story.blocks.7.terrain': 'Collado, cruce Grmada-Šmarna Gora, dos opciones',
  'story.blocks.8.title': 'Cima — Elige tu Ruta',
  'story.blocks.8.text': 'Recomendamos el ascenso más empinado y el descenso más suave. Así experimentas ambos lados de Šmarna Gora y disfrutas de la experiencia completa.',
  'story.blocks.8.terrain': 'Dos rutas, ascenso y descenso',

  'highlight.title': 'Una de las rutas más acogedoras de Šmarna Gora',
  'highlight.text1': 'Esta es también una de las rutas más acogedoras de Šmarna Gora — nunca expuesta, sin grandes pendientes y agradable para caminar incluso después de la lluvia cuando muchos otros senderos están embarrados.',
  'highlight.text2': 'La primera sección es muy variada y por lo tanto extremadamente popular entre excursionistas, corredores y familias.',

  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'VISTAS DESDE LA CIMA',
  'viewpoint.desc': 'En la cima de Šmarna Gora, tómate tiempo en días despejados para disfrutar de magníficas vistas de Liubliana, el río Sava, las colinas circundantes y los Alpes. La cumbre con su pintoresca iglesia ofrece uno de los panoramas más bellos del centro de Eslovenia.',

  'gallery.badge': 'Galería',
  'gallery.title': 'Šmarna Gora a través del objetivo',
  'gallery.subtitle': 'Momentos que dan vida al espíritu de la montaña — cada fotografía cuenta su propia historia',
  'gallery.enlarge': 'Ampliar',
  'gallery.close': 'Cerrar vista previa',
  'gallery.prev': 'Imagen anterior',
  'gallery.next': 'Imagen siguiente',
  'gallery.open': 'Abrir imagen',

  'weather.badge': 'Clima en Vivo',
  'weather.title': 'CLIMA EN ŠMARNA GORA',
  'weather.loading': 'Actualizando...',
  'weather.updated': 'Última actualización',
  'weather.current': 'Actual',
  'weather.feels_like': 'Sensación',
  'weather.wind': 'Viento',
  'weather.humidity': 'Humedad',
  'weather.visibility': 'Visibilidad',
  'weather.cloud_cover': 'Nubosidad',
  'weather.uv_index': 'Índice UV',
  'weather.rain': 'Lluvia',
  'weather.hiking_score': 'Puntuación de Senderismo',
  'weather.out_of': 'de 100 puntos',
  'weather.trail_safety': 'Seguridad del Sendero',
  'weather.safety_optimal': 'Condiciones Seguras',
  'weather.safety_caution': 'Precaución Necesaria',
  'weather.safety_warning': 'Condiciones Difíciles',
  'weather.safety_danger': 'Condiciones Peligrosas',
  'weather.no_alerts': 'Sin avisos especiales',
  'weather.best_time': 'Mejor Hora para Senderismo',
  'weather.next_hours': 'Próximas Horas',
  'weather.seven_day': 'Previsión 7 Días',
  'weather.disclaimer': 'Los datos son solo informativos. Consulta siempre el pronóstico meteorológico oficial antes de hacer senderismo. Fuente: Open-Meteo API.',
  'weather.error_load': 'No se pudieron cargar los datos meteorológicos',
  'weather.error_stale': 'Mostrando últimos datos guardados',
  'weather.smarna_elevation': 'Šmarna Gora, 669m',

  'safety.badge': 'Importante',
  'safety.title': 'SEGURIDAD EN EL SENDERO',
  'safety.slippery_title': 'Superficie Resbaladiza',
  'safety.slippery_desc': 'Después de la lluvia, las raíces y rocas son extremadamente resbaladizas. Usa botas de senderismo con buen agarre. Evita atajos por terreno mojado.',
  'safety.winter_title': 'Condiciones Invernales',
  'safety.winter_desc': 'En invierno, los senderos pueden estar helados. El equipo de invierno es esencial: crampones, bastones de senderismo. Consulta el clima antes de salir.',
  'safety.sunset_title': 'Amanecer / Atardecer',
  'safety.sunset_desc': 'Si sales para el amanecer o atardecer, lleva siempre un frontal. Siempre dile a alguien tu destino.',
  'safety.emergency_title': 'Emergencia',
  'safety.emergency_desc': 'En caso de emergencia, llama al 112. La app del Rescate de Montaña permite una localización rápida. Guarda el número antes de tu excursión.',
  'safety.warning_title': 'ADVERTENCIA',
  'safety.warning_text': 'La información en esta página es solo informativa. El senderismo se realiza bajo tu propia responsabilidad. Antes de cada excursión, verifica las condiciones meteorológicas, asegura el equipo adecuado y evalúa tu condición física. STEZA no asume ninguna responsabilidad por posibles lesiones o accidentes.',

  'facebook.badge': 'Comunidad',
  'facebook.title': 'ÚNETE A NOSOTROS',
  'facebook.desc': 'Sigue a STEZA.SI en Facebook para las últimas noticias, eventos y fotos',
  'facebook.label': 'Comunidad de Facebook',

  'webcam.badge': 'En Directo',
  'webcam.title': 'WEBCAM ŠMARNA GORA',
  'webcam.desc': 'Vista en directo desde la cima de Šmarna Gora — próximamente',
  'webcam.coming_soon': 'Webcam próximamente disponible',
  'webcam.preparing': 'Estamos preparando una transmisión en directo desde la cima de Šmarna Gora. Gracias por tu paciencia.',
  'webcam.status': 'En preparación',

  'media.badge': 'Media',
  'media.title': 'GALERÍA Y VIDEO',
  'media.desc': 'Imágenes cinematográficas y fotografía de Šmarna Gora — próximamente',
  'media.drone': 'VIDEO CON DRON EN PRODUCCIÓN',
  'media.drone_desc': 'Grabación cinematográfica de la Ruta Peske',
  'media.views': 'Vistas',
  'media.trail': 'Sendero',
  'media.history': 'Historia',

  'footer.desc': 'La Ruta Peske — Šmarna Gora. Asociación Turística STEZA. Una experiencia de senderismo premium con información profesional sobre rutas, clima y seguridad.',
  'footer.newsletter_title': 'Recibe Novedades de Rutas',
  'footer.newsletter_success': '¡Gracias! Estás suscrito a las noticias de STEZA.',
  'footer.newsletter_placeholder': 'Introduce tu email',
  'footer.newsletter_btn': 'Suscribirse',
  'footer.trails': 'Rutas',
  'footer.platform': 'Plataforma',
  'footer.legal': 'Legal',
  'footer.pot_peske': 'Ruta Peske',
  'footer.pot_korenine': 'Sendero de las Raíces',
  'footer.mazijeva': 'Sendero Mazi',
  'footer.romarska': 'Sendero del Peregrino',
  'footer.plezalna': 'Vía Ferrata',
  'footer.izhodisca': 'Puntos de Partida',
  'footer.galerija': 'Galería',
  'footer.vreme': 'Clima',
  'footer.o_stezi': 'Sobre STEZA',
  'footer.kontakt': 'Contacto',
  'footer.privacy': 'Política de Privacidad',
  'footer.cookies': 'Cookies',
  'footer.disclaimer': 'Aviso Legal',
  'footer.safety_notice': 'Aviso de Seguridad',
  'footer.copyright': '© 2026 STEZA.SI — Asociación Turística STEZA, Šmarna Gora',
  'footer.disclaimer_text': 'Aviso importante: La información en este sitio es solo informativa. El senderismo y las actividades al aire libre se realizan bajo tu propia responsabilidad. Consulta las condiciones meteorológicas, el equipo adecuado y el estado de los senderos antes de tu visita.',
  'footer.facebook_label': 'STEZA en Facebook',
  'footer.instagram_label': 'STEZA en Instagram',

  'about.hero_title': 'Sobre STEZA',
  'about.hero_subtitle': 'Una plataforma de senderismo premium, creada con amor por Šmarna Gora.',
  'about.story_badge': 'Nuestra Historia',
  'about.story_title': 'La ruta más hermosa de Šmarna Gora',
  'about.story_p1': 'STEZA nació de una idea simple: hacer senderismo en Šmarna Gora puede ser más que solo recreación — puede ser una experiencia. Creamos una plataforma que combina información profesional de senderismo con una estética excepcional y tecnología moderna.',
  'about.story_p2': 'Somos un equipo de excursionistas, fotógrafos y diseñadores que creen que cada montaña merece su propia presentación premium. Šmarna Gora no es solo una colina — es un símbolo de Liubliana, un destino de peregrinación, una joya natural y un estadio deportivo, todo en uno.',
  'about.story_p3': 'STEZA no es un portal turístico. No es un blog. Es una plataforma cinematográfica premium de senderismo para todos los que quieren descubrir Šmarna Gora de manera diferente.',
  'about.elevation_label': 'Šmarna Gora',
  'about.elevation': '669 m s. n. m.',
  'about.how_title': 'Cómo Nació STEZA',
  'about.how_p1': 'La historia comenzó en la cima de Šmarna Gora. Estábamos en la plataforma panorámica, mirando hacia los Alpes y nos preguntamos: ¿por qué una colina tan hermosa no tiene una presencia en línea moderna, clara y bonita? Todo lo que encontramos fueron publicaciones dispersas en foros, blogs obsoletos y fotos de baja calidad. Fue entonces cuando decidimos — crearíamos algo diferente.',
  'about.how_p2': 'Pasamos los siguientes seis meses en el terreno. Recorrimos cada sendero — desde el más fácil hasta el más exigente. Fotografiamos amaneceres, bosques lluviosos, cumbres nevadas y atardeceres dorados. Hablamos con guías locales, posaderos, excursionistas experimentados y visitantes primerizos. Queríamos entender Šmarna Gora desde cada ángulo.',
  'about.how_p3': 'STEZA no es solo un sitio web. Es un diario visual de nuestro amor por esta montaña. Cada fotografía está tomada profesionalmente, cada sendero recorrido personalmente, cada dato verificado. Creemos que Šmarna Gora — como uno de los destinos de senderismo más visitados de Eslovenia — merece una presentación de clase mundial.',
  'about.how_p4': 'La inspiración para el diseño la tomamos de marcas outdoor premium como Patagonia, The North Face y National Geographic Travel. Queríamos crear una plataforma que respire aventura manteniéndose minimalista, limpia y profesional.',
  'about.how_p5': 'Hoy STEZA cubre cuatro rutas principales a Šmarna Gora, datos meteorológicos en vivo, navegación GPS, pautas de seguridad y una rica galería. Pero esto es solo el comienzo. Nuestra visión es convertirnos en la mejor plataforma de senderismo de Eslovenia — y Šmarna Gora es nuestro primer y más querido proyecto.',
  'about.gora_badge': 'Descubre la Montaña',
  'about.gora_title': 'Šmarna Gora — el corazón de nuestra historia',
  'about.gora_subtitle': '669 metros que conectan generaciones',
  'about.gora_p1': 'Šmarna Gora (669 m) es la cumbre de senderismo más popular del centro de Eslovenia. Se encuentra a solo 10 kilómetros al noroeste de Liubliana, pero a pesar de su cercanía a la ciudad, ofrece un contacto auténtico con la naturaleza, una rica historia y vistas impresionantes.',
  'about.gora_p2': 'Es un inselberg — una colina que geológicamente no pertenece a ninguna cordillera mayor, sino que se eleva independientemente sobre la Cuenca de Liubliana. Compuesta de caliza y dolomía, sus laderas sur son conocidas por especies vegetales termófilas.',
  'about.gora_p3': 'A lo largo de los siglos, Šmarna Gora ha sido todo: un asentamiento prehistórico, un punto estratégico con el Castillo de Šumberk, un destino de peregrinación, un popular lugar de excursión para los ciudadanos, y hoy es una parte indispensable de la identidad deportiva y cultural de Liubliana.',
  'about.history_title': 'Historia Tallada en Piedra',
  'about.history_bronze_date': '1500 a. C.',
  'about.history_bronze_title': 'Edad del Bronce',
  'about.history_bronze_text': 'Los hallazgos arqueológicos en la cima atestiguan un asentamiento prehistórico. Cerámica, herramientas y restos de viviendas indican una ocupación permanente durante la Edad del Bronce.',
  'about.history_castle_date': 'Siglos XII–XIII',
  'about.history_castle_title': 'Castillo de Šumberk',
  'about.history_castle_text': 'El castillo medieval de Šumberk (Schönberg) se alzaba en la cima. Hoy solo quedan modestos vestigios arqueológicos y leyendas de caballeros.',
  'about.history_church_date': '1711',
  'about.history_church_title': 'Iglesia de la Madre de Dios',
  'about.history_church_text': 'Se construyó una iglesia barroca en el lugar de una iglesia gótica anterior del siglo XIV. Se convirtió en el destino central de peregrinación del centro de Eslovenia.',
  'about.history_modern_date': 'Siglo XIX–hoy',
  'about.history_modern_title': 'Destino Alpino',
  'about.history_modern_text': 'Con el desarrollo del montañismo, se convirtió en el destino de senderismo más popular para los habitantes de Liubliana. Mantiene este estatus hoy con más de 500.000 visitantes anuales.',
  'about.nature_title': 'Naturaleza que Inspira',
  'about.nature_p1': 'Las laderas sur de Šmarna Gora son un paraíso botánico. El cálido microclima favorece plantas que normalmente se encuentran mucho más al sur: el eléboro negro florece ya en febrero, seguido por el lirio fragante, la pulsatila común y el cólquico de otoño.',
  'about.nature_p2': 'Los bosques son mixtos — dominan el haya, el roble y el abeto, con un magnífico castaño en la cima. La fauna incluye ciervos, zorros, jabalíes, tejones, ardillas y lirones.',
  'about.nature_p3': 'Promovemos el senderismo responsable — no dejes rastro, no arranques plantas, no molestes a los animales y llévate la basura al valle.',
  'about.legends_title': 'Leyendas que Viven',
  'about.legend_bell_title': 'La Campana de los Deseos',
  'about.legend_bell_text': 'La leyenda más famosa de Šmarna Gora. Si tocas la campana tres veces — la primera por salud, la segunda por suerte y la tercera por amor — pidiendo un deseo en cada toque, tu deseo se hará realidad.',
  'about.legend_castle_title': 'El Castillo de Šumberk y el Tesoro',
  'about.legend_castle_text': 'La leyenda cuenta que los caballeros del Castillo de Šumberk, antes de partir a las Cruzadas, enterraron un tesoro de oro en algún lugar de las laderas de Šmarna Gora. Nunca ha sido encontrado.',
  'about.legend_mary_title': 'La Aparición de María',
  'about.legend_mary_text': 'Según la tradición popular, la Virgen María apareció en la cima de la colina, dando nombre a la montaña. Esta tradición llevó a la construcción de la iglesia y a una tradición de peregrinación que dura más de 300 años.',
  'about.stats_title': 'STEZA en Cifras',
  'about.values_title': 'Nuestros Valores',
  'about.values.professionalism': 'Profesionalidad',
  'about.values.professionalism_text': 'Toda la información está cuidadosamente verificada y se actualiza regularmente. Colaboramos con guías locales y el Rescate de Montaña.',
  'about.values.aesthetics': 'Estética',
  'about.values.aesthetics_text': 'Creemos que las bellas imágenes son clave para la inspiración. Cada fotografía en el sitio está tomada y curada profesionalmente.',
  'about.values.safety': 'Seguridad',
  'about.values.safety_text': 'La seguridad es lo primero. Cada ruta incluye advertencias detalladas, equipo recomendado y pautas de seguridad.',
  'about.values.passion': 'Pasión',
  'about.values.passion_text': 'STEZA es un proyecto nacido de la pasión. Cada miembro del equipo es un excursionista que conoce personalmente cada sendero de Šmarna Gora.',
  'about.values.sustainability': 'Sostenibilidad',
  'about.values.sustainability_text': 'Promovemos el senderismo responsable. No dejes rastro, respeta la naturaleza y la fauna, llévate la basura contigo.',
  'about.values.community': 'Comunidad',
  'about.values.community_text': 'Estamos construyendo una comunidad de excursionistas que comparten experiencias y se ayudan mutuamente a descubrir Šmarna Gora.',
  'about.cta_title': 'Únete a STEZA',
  'about.cta_subtitle': 'Cada ruta tiene una historia. Descúbrela con nosotros.',
  'about.cta_explore': 'Explorar Rutas',
  'about.cta_contact': 'Contáctanos',

  'contact.hero_title': 'Contacto',
  'contact.hero_subtitle': '¿Tienes una pregunta, sugerencia o deseas colaborar? Escríbenos o llámanos.',
  'contact.write_us': 'Escríbenos',
  'contact.email_label': 'Correo electrónico',
  'contact.phone_label': 'Teléfono',
  'contact.location_label': 'Ubicación',
  'contact.location_value': 'Šmarna Gora, 1211 Liubliana-Šmartno, Eslovenia',
  'contact.follow_us': 'Síguenos',
  'contact.success_title': '¡Gracias por tu mensaje!',
  'contact.success_text': 'Te responderemos lo antes posible.',
  'contact.name_label': 'Nombre',
  'contact.name_placeholder': 'Tu nombre',
  'contact.email_placeholder': 'tu@email.es',
  'contact.message_label': 'Mensaje',
  'contact.message_placeholder': 'Tu mensaje (máx. 500 caracteres)',
  'contact.submit': 'Enviar Mensaje',
  'contact.error_fields': 'Por favor, completa todos los campos.',
  'contact.error_length': 'Mensaje demasiado largo. Máximo 500 caracteres.',
  'contact.error_general': 'Ocurrió un error. Inténtalo de nuevo.',

  'routes.hero_title': 'Rutas',
  'routes.hero_subtitle': 'Cinco rutas únicas hasta la cima de Šmarna Gora. Desde la fácil Ruta Peske hasta las exigentes vías ferratas — elige tu STEZA.',
  'routes.explore': 'Explorar Ruta',
  'routes.compare_title': 'Comparativa de Rutas',
  'routes.table_pot': 'Ruta',
  'routes.table_tezavnost': 'Dificultad',
  'routes.table_trajanje': 'Duración',
  'routes.table_visinska': 'Desnivel',
  'routes.table_dolzina': 'Longitud',
  'routes.table_tip': 'Tipo',
  'routes.cta_title': '¿Listo para tu STEZA?',
  'routes.cta_subtitle': 'Elige la ruta que mejor se adapte a ti y descubre Šmarna Gora de una manera que recordarás.',
  'routes.cta_find': 'Encontrar Punto de Partida',
  'routes.cta_weather': 'Consultar Clima',
  'routes.difficulty_easy': 'Fácil',
  'routes.difficulty_moderate': 'Moderado',
  'routes.difficulty_hard': 'Difícil',

  'gallery_page.badge': 'Colección Fotográfica',
  'gallery_page.title': 'Galería',
  'gallery_page.subtitle': 'Una colección de fotografías de Šmarna Gora — rutas, vistas y momentos que compartimos.',
  'gallery_page.section_trail_title': 'El Camino a la Cima',
  'gallery_page.section_trail_subtitle': 'Senderos de montaña a través del bosque y la naturaleza durante la ascensión',
  'gallery_page.section_summit_title': 'La Cima',
  'gallery_page.section_summit_subtitle': 'Vistas, panoramas y momentos en la cima de Šmarna Gora',
  'gallery_page.section_parking_title': 'Aparcamiento',
  'gallery_page.section_parking_subtitle': 'Acceso al punto de partida y estacionamiento durante todas las estaciones',
  'gallery_page.empty_title': 'La sección {title} está lista. Añade imágenes y aparecerán aquí.',
  'gallery_page.empty_subtitle': 'Sección lista.',
  'gallery_page.close': 'Cerrar galería',
  'gallery_page.prev': 'Imagen anterior',
  'gallery_page.next': 'Imagen siguiente',
  'gallery_page.open': 'Ver imagen',
  'gallery_page.cta_title': 'Captura Tu Propia Foto',
  'gallery_page.cta_subtitle': 'Las fotos más hermosas se toman en la cima. Comparte tus mejores tomas con el hashtag #STEZA.',
  'gallery_page.cta_btn': 'Encuentra Tu Ruta',

  'legal.not_found': 'Página no encontrada',
  'legal.back_home': '← Volver al inicio',
  'legal.updated': 'Última actualización',
  'legal.copyright': '© 2026 STEZA.SI — Todos los derechos reservados. Contacto: info@steza.si',

  'notfound.title': 'Esta página aún no ha sido generada',
  'notfound.subtitle': 'Cuéntame más sobre esta página, para poder generarla',
  'notfound.back_home': 'Volver al inicio',

  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  'seo.home_title': 'Ruta Peske — Šmarna Gora | STEZA — Plataforma Premium de Senderismo',
  'seo.home_desc': 'La Ruta Peske es uno de los caminos más hermosos hacia Šmarna Gora. Una experiencia de senderismo premium con información profesional sobre rutas, clima, seguridad y miradores. Asociación Turística STEZA.',
  'seo.home_keywords': 'Ruta Peske, Šmarna Gora, senderismo Šmarna Gora, senderismo Eslovenia, rutas Šmarna Gora, senderismo Liubliana, montañismo Eslovenia',
  'seo.og_title': 'Ruta Peske — Šmarna Gora | STEZA',
  'seo.og_desc': 'Plataforma premium de senderismo para Šmarna Gora. Descubre la Ruta Peske — uno de los caminos más hermosos y acogedores hacia Šmarna Gora.',
  'seo.schema_desc': 'La Ruta Peske es uno de los caminos más hermosos hacia Šmarna Gora. Asociación Turística STEZA — una plataforma premium de senderismo para Šmarna Gora.',
};